import { render } from "./ListarTiposPagamentos.vue?vue&type=template&id=208a85ea"
import script from "./ListarTiposPagamentos.vue?vue&type=script&lang=js"
export * from "./ListarTiposPagamentos.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__